
// Note: this RegEx allows an S character in position 2 which indicates a synthetic MBI
export const mbiRegex = /[1-9](?![LOIB])[A-Ya-y](?![SLOIB])[A-Ya-y0-9]{1}\d-?(?![SLOIB])[A-Ya-y]{1}(?![SLOIB])[A-Ya-y0-9]{1}\d-?(?![SLOIB])[A-Ya-y]{2}\d\d/;
const isExactlyMbi = new RegExp(`^${mbiRegex.source}$`)

export function isValidMedicareNumber(medicareNumber: string) {
    return !!medicareNumber.match(isExactlyMbi);
}
